import { render } from "./partnerCreate.vue?vue&type=template&id=3a9a3476&scoped=true"
import script from "./partnerCreate.vue?vue&type=script&lang=js"
export * from "./partnerCreate.vue?vue&type=script&lang=js"

import "./partnerCreate.vue?vue&type=style&index=0&id=3a9a3476&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a9a3476"]])

export default __exports__